import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout, logoutUser } from "../redux/authSlice"; // Import auth actions
import "./AppBar.css";
import OpenBookIcon from "./OpenBookIcon";

import Images from "../assests/imgs/Imges";

import PartsPopup from "./AppSpecificConpnents/PartsTable/PartsPopup";
import TypesPopup from "./AppSpecificConpnents/Types/TypesPopup";
import TaskPopup from "../pages/Tasks/TaskPopup";

const VersionHistoryCopyAppBar = ({
  title = "",
  showTablesDropdown = true,
  buttons = [],
  buttonsBeforeTitle = [],
  showBackButton = true,
  showProfileButton = true,
  showColorTitle = false,
  showBlackTitle = true,
  showEyeIcon = false,
  showQuestionIcon = false,
  showBookmark = false,
  subheading = "",
  navigateTwoPagesBack = false,
  subheadingAfterTitle = "",
  disableBarButtons = false,
  showCancelButton = false,
  showCreateCopyCheckbox = false,
  createCopy = false,
  onCreateCopyChange = () => {},
  showViewToggle = false,
  selectedView = "original",
  onViewChange = () => {},
  onCancel,
  subheadingBelowTitle = "",
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  // const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showTabelPopup, setTablePopup] = useState({
    show: false,
    type: "",
    title: "Item Code Table",
  });

  const handleDrpdnClick = (title, type) => {
    setTablePopup({ show: true, type: type, title: title });
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLiveMode = useSelector((state) => state.liveMode.isLive);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  // For testing purposes, you can temporarily override isAdmin
  const isAdmin = true; // Set this to true to test admin view
  // const isAdmin = user?.permission_to_edit === "Admin" || user?.permission_to_edit === "Superadmin";

  // Force show profile image for testing
  const showProfileImage = true;
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate(-1);
    }
  };
  const closePopup = () => {
    setTablePopup((prev) => ({ ...prev, show: false }));
  };
  return (
    <>
      <header className="appbar" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px" }}>
        {/* Left Section */}
        <div style={{ display: "flex", alignItems: "center", gap: "15px", flexShrink: 0 }}>
          {showCancelButton && (
            <button
              onClick={handleCancel}
              style={{
            backgroundColor: "#f1f3f4",
            color: "#47515c",
            border: "none",
            padding: "8px 12px",
            cursor: "pointer",
            borderRadius: "4px",
            marginLeft: "15px",
            marginRight: "15px",
          }}
            >
              Cancel
            </button>
          )}

          {showCreateCopyCheckbox && (
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={createCopy}
                onChange={onCreateCopyChange}
                style={{ width: "14px", height: "14px" }}
              />
              <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                Create a Copy
              </span>
            </label>
          )}

          {/* Radio Buttons for View Toggle */}
          {showViewToggle && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <label
                style={{
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="radio"
                  name="view"
                  value="original"
                  checked={selectedView === "original"}
                  onChange={(e) => onViewChange(e.target.value)}
                  style={{ cursor: "pointer" }}
                />
                <span
                  style={{ fontSize: "10px", whiteSpace: "nowrap", marginTop: "3px" }}
                >
                  View Original
                </span>
              </label>
              <label
                style={{
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="radio"
                  name="view"
                  value="new"
                  checked={selectedView === "new"}
                  onChange={(e) => onViewChange(e.target.value)}
                  style={{ cursor: "pointer" }}
                />
                <span
                  style={{ fontSize: "10px", whiteSpace: "nowrap", marginTop: "3px" }}
                >
                  View New
                </span>
              </label>
            </div>
          )}

          {/* Buttons Before Title */}
          {buttonsBeforeTitle.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {buttonsBeforeTitle.map((button, index) => (
                <button
                  key={index}
                  className="reject-button"
                  onClick={button.onClick || (() => navigate(button.path))}
                  disabled={disableBarButtons}
                >
                  {button.label}
                </button>
              ))}
            </div>
          )}

          {showBackButton && (
            <button className="back-button" onClick={() => window.history.back()}>
              <svg
                viewBox="6 4 16 16"
                width="48"
                height="48"
                style={{ color: "#0D6EFD" }}
              >
                <path
                  d="M10 12h10M10 12l4-4M10 12l4 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}

          {subheading && (
            <p style={{ fontSize: "12px", margin: 0 }}>{subheading}</p>
          )}
        </div>

        {/* Center Section - Title */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            flex: 1,
            minWidth: 0,
            padding: "0 20px",
          }}
        >
          {isLiveMode && <h2 style={{ margin: 0 }}>Previewing</h2>}
          <h2
            style={{
              color: "#0D6EFD",
              fontSize: "20px",
              margin: "-16px 0 8px 0",
              textAlign: "center",
              width: "100%",
            }}
          >
            {title}
          </h2>
          {subheadingBelowTitle && (
            <p
              style={{
                color: "#000000",
                fontSize: "12px",
                maxWidth: "700px",
                lineHeight: "1.4",
                wordBreak: "break-word",
                margin: "5px 0 0 0",
                textAlign: "center",
                width: "100%",
                display: "block",
              }}
            >
              {subheadingBelowTitle}
            </p>
          )}
        </div>

        {/* Right Section */}
        <div className="appbar-buttons" style={{ flexShrink: 0 }}>
          {/* ✅ Subheading after title */}
          {subheadingAfterTitle && (
            <p style={{ marginLeft: "10px", fontSize: "12px" }}>
              {subheadingAfterTitle}
            </p>
          )}
          {buttons.map((button, index) => (
            <button
              key={index}
              className={`${
                button.label !== "Preview" &&
                button.label !== "Request Change" &&
                !button.label.toLowerCase().includes("move") &&
                !button.label.toLowerCase().includes("paste")
                  ? "appbar-button"
                  : "appbar-button-secondary"
              }`}
              onClick={button.onClick || (() => navigate(button.path))}
              disabled={disableBarButtons || button.disabled}
            >
              {button.label}
            </button>
          ))}
        </div>
      </header>
    </>
  );
};

export default VersionHistoryCopyAppBar;
